import React from 'react';
import Box from '@mui/material/Box';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import AddIcon from '@mui/icons-material/Add';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ExportIcon from '@mui/icons-material/GetApp';
import RefreshIcon from '@mui/icons-material/Refresh';
import { motion } from 'framer-motion';
import { Link as RouterLink } from 'react-router-dom';

const DeductionsHeader = ({
  title = 'Deductions Dashboard',
  breadcrumbs = [],
  isMobile,
  exportDisabled,
  onRefresh,
  onExport,
  backAction,
  primaryAction
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35 }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: 'space-between',
          alignItems: { xs: 'flex-start', md: 'center' },
          gap: 2,
          mb: 2
        }}
      >
        <Box>
          <Typography variant={isMobile ? 'h5' : 'h4'} sx={{ fontWeight: 700, color: '#111827' }}>
            {title}
          </Typography>
          <Breadcrumbs sx={{ mt: 0.75 }}>
            <Link component={RouterLink} underline="hover" color="inherit" to="/">
              Dashboard
            </Link>
            {breadcrumbs.map((item) =>
              item.to ? (
                <Link key={`${item.label}-${item.to}`} component={RouterLink} underline="hover" color="inherit" to={item.to}>
                  {item.label}
                </Link>
              ) : (
                <Typography key={item.label} color="text.primary">
                  {item.label}
                </Typography>
              )
            )}
          </Breadcrumbs>
        </Box>

        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.25} sx={{ width: { xs: '100%', md: 'auto' } }}>
          {backAction && (
            <Button
              startIcon={<ArrowBackIcon />}
              variant="outlined"
              onClick={backAction.onClick}
              sx={{
                borderRadius: 2.5,
                textTransform: 'none',
                borderColor: '#d1d5db',
                color: '#374151'
              }}
            >
              {backAction.label}
            </Button>
          )}
          <Button
            startIcon={<RefreshIcon />}
            variant="outlined"
            onClick={onRefresh}
            sx={{
              borderRadius: 2.5,
              textTransform: 'none',
              borderColor: '#d1d5db',
              color: '#374151'
            }}
          >
            Refresh
          </Button>
          {primaryAction && (
            <Button
              startIcon={<AddIcon />}
              variant="contained"
              onClick={primaryAction.onClick}
              sx={{
                borderRadius: 2.5,
                textTransform: 'none',
                backgroundColor: primaryAction.color || '#12C1DC',
                color: '#ffffff',
                boxShadow: 'none',
                '&:hover': {
                  backgroundColor: primaryAction.color || '#12C1DC',
                  boxShadow: 'none',
                  opacity: 0.92
                }
              }}
            >
              {primaryAction.label}
            </Button>
          )}
        </Stack>
      </Box>
    </motion.div>
  );
};

export default DeductionsHeader;
